import { commitmentTranslations } from "./commitment";

export const translations = {
  en: {
    comuTitle: "Catholic Community El Salvador Del Mundo",
    mainPhrase: "United in faith and service to our community.",
    copyright: "Catholic Community El Salvador Del Mundo. All rights reserved.",
    close: "Close",
    appTitle: "Bible Study",
    loginWelcomeMessage: "Welcome",
    loginPasswordPlaceholder: "Password",
    loginUserPlaceholder: "Username",
    loginButtonText: "Submit",
    loginBiblicalQuote: `The Lord said to me, “Speak a prophetic message to these bones and say, ‘Dry bones, listen to the word of the Lord! This is what the Sovereign
Lord says: Look! I am going to put breath into you and make you live again! I will put flesh and muscles on you and cover you with skin. I will put breath into you, and you will come to life. Then you will know that I am the Lord.`,
    loginBiblicalQuoteReference: "Ezekiel 37:4",
    loginUserNameRequired: "Username is required",
    loginPasswordRequired: "Password is required",
    loginGenericError: "An error occurred. Please try again later.",
    contact: "Contact",
    genericErrorTitle: "An error occurred",
    mainMenuHome: "Home",
    mainMenuEvents: "Events",
    mainMenuServices: "Meetings",
    mainMenuSecurity: "Security",
    mainMenuInvitations: "Invitations",
    mainMenuCommitments: "Commitment",
    eventFilterTitle: "Main Filters",
    eventFilterGroupPlaceholder: "Groups",
    eventFilterPlaceholder: "Events",
    logout: "Logout",
    eventMenuInscription: "Inscription",
    eventMenuIncome: "Income",
    eventMenuRooms: "Rooms",
    eventMenuComissions: "Comissions",
    eventMenuWorkshops: "Workshops",
    eventMenuDashboard: "Dashboard",
    eventMenuSummaryByGroup: "Summary by Group",
    eventMenuServers: "Servers",
    eventMenuAttendance: "Attendance",
    eventMenuDashboardTitle: "Event Summary",
    attendanceIndicatorTitle: "Attendance count",
    eventMenuPrint: "Print",
    eventMenuConfig: "Configurations",
    eventMenuFilters: "Filters",
    eventMenuRefresh: "Refresh",
    eventMenuCalls: "Calls",
    guestGridSearchPlaceholder: "Search...",
    guestGridColPhone: "Phone",
    guestGridColName: "Name",
    guestGridColLastName: "Last Name",
    guestGridColAge: "Age",
    guestGridColGender: "Gender",
    guestGridColGroup: "Group",
    guestGridColMaritalStatus: "Marital Status",
    guestGridColSpecialFood: "Esp Food",
    guestGridColHasIllnes: "Has Illness",
    guestGridColExtraFood: "Extra Food",
    guestGridColExtraStay: "Extra Stay",
    guestGridColConvertionDate: "Convertion Date",
    guestGridColStatus: "Status",
    guestGridColPaymentStatus: "Payment Status",
    guestGridColCalls: "Calls",
    guestGridColVechicle: "Vechicle",
    guestGridColWhoRecommended: "Who Recommended",
    guestGridFiltersTitle: "Filters",
    guestGridFilterGuests: "Guests",
    guestGridFilterServers: "Servers",
    guestGridFilterAll: "All",
    guestGridFilterConfirmed: "Confirmed",
    guestGridFilterInvited: "Invited",
    guestGridFilterRegistered: "Registered",
    guestGridFilterPending: "Pending",
    guestGridFilterNext: "Next",
    guestGridFilterPaymentComplete: "Completed",
    guestGridFilterPaymentPending: "Pending",
    guestGridFilterPaymentPartial: "Partial",
    guestGridFilterEspetialFood: "Special Food",
    guestGridFilterIllness: "Illness",
    guestGridFilterMale: "Male",
    guestGridFilterFemale: "Female",
    guestGridFilterBringingVehicle: "Bringing Vehicle",
    guestGridFilterNoAttendance: "No Attendance",
    guestGridFilterItAttendance: "Attendance",
    attendancePendingTitle: "Pending Attendance",
    guestGridFilterExtraStay: "Extra Stay",
    guestGridFilterExtraFood: "Extra Food",
    guestGridFilterType: "Type",
    guestGridFilterStatus: "Confirmation Status",
    guestGridFilterPayment: "Payment Status",
    guestGridFilterIssues: "Search by Issues",
    guestGridFilterGender: "Gender",
    guestGridFilterAttendance: "Attendance",
    guestGridFilterOther: "Other",
    attendanceTitle: "Attendance",
    attendanceNotToday: "Attendance can only be marked on retreat days ({date}).",
    meetingServiceStartTime: "Start Time",
    meetingServiceEndTime: "End Time",
    selectMeeting: "Select a meeting",
    availableServers: "Available Servers",
    noAssignedServers: "No servers assigned yet",
    assignedServers: "Assigned Servers",
    assign: "Assign",
    total: "Total",
    male: "Male",
    female: "Femenino",
    married: "Married",
    single: "Single",
    divorced: "Divorced",
    widowed: "Widowed",
    accompaned: "Accompanied",
    yes: "Yes",
    no: "No",
    confirmed: "Confirmed",
    invited: "Invited",
    callPending: "Call Pending",
    nextTime: "Next Time",
    pendingPayment: "Pending",
    paymentComplete: "Complete",
    paymentPartial: "Partial",
    brand: "Brand",
    plate: "Plate",
    transfer: "Transfer",
    cash: "Cash",
    check: "Check",
    other: "Other",
    edit: "Edit",
    call: "Call",
    date: "Date",
    eventDoneMessage: "The event was done on {date}",
    addInvitation: "Create Invitation",
    servicesTabTitle: "Services",
    addServer: "Add Server",
    editServer: "Edit Server",
    attendanceGridColName: "Name",
    attendanceGridColAge: "Age",
    attendanceGridColLastName: "Last Name",
    attendanceGridColPhone: "Phone",
    attendanceGridColRoom: "Room",
    attendanceGridColHouse: "House",
    attendanceGridColWorkshop: "Workshop",
    attendanceGridColAttendance: "Attendance",
    attendanceGridColPayment: "Payment",
    attendanceGridColViewProfile: "View Profile",
    assignWorkshopsByAge: "Assign Workshops by Age",
    all: "All",
    groups: "Groups",
    of: "of",
    paymentsList: "Payments List",
    rooms: "Rooms",
    roomsNoEditAccess: "You don't have permissions to edit rooms",
    currentTotalServers: "Current Total Servers",
    groupByAgeBarChartTitle: "Group by Age",
    groupByMaritalStatusBarChartTitle: "Group by Marital Status",
    groupByMinistryBarChartTitle: "Group by Ministry",
    groupByConvertionYearsBarChartTitle: "Group by Convertion Years",
    nextRetreats: "Next Retreats",
    available: "Available",
    notAvailable: "Not Available",
    priests: "Priests",
    firstFloor: "1st Floor",
    secondFloor: "2nd Floor",
    marysHouse: "Mary's House",
    searchRoomsPlaceholder: "Search by room number...",
    noConnection: "No internet connection",
    confirmUpdateWorkshopsByAge: "Are you sure you want to update the workshops by age?",
    configWorkshopsCount: "Configure workshops count",
    uploadPayment: "Upload Payment",
    paymentsHistory: "Payments History",
    accept: "Accept",
    availableBeds: "Available Beds",
    dashboard: "Dashboard",
    assignedServices: "Assigned Services",
    assignServicesCaption: "Assign servers to services for upcoming meetings",
    selectMeetingHelperText: "Please select a meeting to start assigning services",
    serversManagement: "Servers Management",
    serversManagementCaption: "Manage servers and their service skills",
    noMeetingSelected: "No meeting selected",
    servicesManagement: "Services Management",
    servicesManagementCaption: "Manage the different services needed for meetings",
    services: "Services",
    upcommingMeetings: "Upcoming meetings",
    upcommingMeetingsCaption: "View and manage upcoming meetings",
    calendar: "Calendar",
    calendarCaptioon: "Select a date to view meetings",
    serviceStats: "Service Stats",
    serviceStatsCaption: "Overview of service assignments",
    quickActions: "Quick Actions",
    quickActionsCaption: "Common tasks and actions",
    filterByCallName: "Filter by caller",
    paymentNotes: "Payment Notes",
    paymentNotesPlaceholder: "Add payment notes",
    history: "History",
    noRecordsFound: "No records found",
    selectEventPlaceholder: "Select an event",
    groupHasNoEvents: "Group has no events available",
    createNewEvent: "Create new event",
    openFilters: "Open Filters",
    ...commitmentTranslations.en
  },
  es: {
    comuTitle: "Comunidad Católica El Salvador del Mundo",
    mainPhrase: "Unidos en fe y servicio a nuestra comunidad.",
    copyright: "Comunidad Católica El Salvador del Mundo. Todos los derechos reservados.",
    close: "Cerrar",
    loginWelcomeMessage: "Bienvenid/a",
    loginPasswordPlaceholder: "Contraseña",
    loginUserPlaceholder: "Usuario (email)",
    loginButtonText: "Continuar",
    loginBiblicalQuote: ` Entonces el Señor me dijo: “Habla en mi nombre a estos huesos. Diles: ‘Huesos secos, escuchad este mensaje del
          Señor. El Señor os dice: Voy a hacer entrar en vosotros aliento de vida, para que reviváis. Os pondré
          tendones, os rellenaré de carne, os cubriré de piel y os daré aliento de vida para que reviváis.
          Entonces reconoceréis que yo soy el Señor.`,
    loginBiblicalQuoteReference: "Ezequiel 37:4-6",
    loginUserNameRequired: "El usuario es requerido",
    loginPasswordRequired: "La contraseña es requerida",
    loginGenericError: "Ocurrió un error. Por favor inténtalo de nuevo más tarde.",
    contact: "Contacto",
    genericErrorTitle: "Ocurrío un error",
    mainMenuHome: "Inicio",
    mainMenuEvents: "Retiros",
    mainMenuServices: "Asambleas",
    mainMenuSecurity: "Seguridad",
    mainMenuInvitations: "Invitaciones",
    mainMenuCommitments: "Compromiso",
    eventFilterTitle: "Filtros Principales",
    eventFilterGroupPlaceholder: "Grupos",
    eventFilterPlaceholder: "Retiros",
    logout: "Cerrar Sesión",
    eventMenuInscription: "Nueva ficha",
    eventMenuIncome: "Fichas",
    eventMenuRooms: "Habitaciones",
    eventMenuComissions: "Comisiones",
    eventMenuWorkshops: "Talleres",
    eventMenuDashboard: "Total de pagos",
    eventMenuSummaryByGroup: "Resumen por Grupo",
    eventMenuServers: "Servidores",
    eventMenuAttendance: "Control de asistencia",
    eventMenuDashboardTitle: "Resumen del retiro",
    eventMenuPrint: "Imprimir",
    eventMenuConfig: "Configuración",
    eventMenuFilters: "Filtros",
    eventMenuRefresh: "Actualizar",
    eventMenuCalls: "Llamadas",
    guestGridSearchPlaceholder: "Buscar...",
    guestGridColPhone: "Teléfono",
    guestGridColName: "Nombre",
    guestGridColLastName: "Apellido",
    guestGridColAge: "Edad",
    guestGridColGender: "Sexo",
    guestGridColGroup: "Grupo",
    guestGridColMaritalStatus: "Estado Civil",
    guestGridColSpecialFood: "Dieta Esp",
    guestGridColHasIllnes: "Padecimiento",
    guestGridColExtraFood: "Comida Extra",
    guestGridColExtraStay: "Estadia Extra",
    guestGridColConvertionDate: "Fecha de Conversión",
    guestGridColStatus: "Estado",
    guestGridColPaymentStatus: "Estado de Pago",
    guestGridColCalls: "Llamadas",
    guestGridFiltersTitle: "Filtros",
    guestGridColVechicle: "Vehículo",
    guestGridFilterGuests: "Participantes",
    guestGridColWhoRecommended: "Recomendado por",
    guestGridFilterServers: "Servidores",
    guestGridFilterAll: "Todos",
    guestGridFilterConfirmed: "Confirmados",
    guestGridFilterInvited: "Invitados",
    guestGridFilterRegistered: "Inscritos",
    guestGridFilterPending: "Pendientes",
    guestGridFilterNext: "Próximo",
    guestGridFilterPaymentComplete: "Pago Completado",
    guestGridFilterPaymentPending: "Pago Pendientes",
    guestGridFilterPaymentPartial: "Parciales",
    guestGridFilterEspetialFood: "Dieta Especial",
    guestGridFilterIllness: "Padecimiento",
    guestGridFilterMale: "Hombres",
    guestGridFilterFemale: "Mujeres",
    guestGridFilterBringingVehicle: "Lleva Vehículo",
    guestGridFilterNoAttendance: "No asistió",
    guestGridFilterItAttendance: "Asistió",
    guestGridFilterExtraStay: "Estadia Extra",
    guestGridFilterExtraFood: "Comida Extra",
    guestGridFilterType: "Tipo",
    guestGridFilterStatus: "Estado de Confirmación",
    guestGridFilterPayment: "Estado de Pago",
    guestGridFilterIssues: "Buscar por Padecimientos",
    guestGridFilterGender: "Sexo",
    guestGridFilterAttendance: "Asistencia",
    guestGridFilterOther: "Otros",
    meetingServiceStartTime: "Hora de Inicio",
    meetingServiceEndTime: "Hora de Fin",
    selectMeeting: "Seleccionar una reunión",
    availableServers: "Servidores Disponibles",
    noAssignedServers: "Aún no hay servidores asignados",
    assignedServers: "Servidores Asignados",
    assign: "Asignar",
    total: "Total",
    male: "Masculino",
    female: "Femenino",
    add: "Agregar",
    save: "Guardar",
    delete: "Eliminar",
    married: "Casado (a)",
    single: "Soltero (a)",
    divorced: "Divorciado (a)",
    widowed: "Viudo (a)",
    accompaned: "Acompañado (a)",
    yes: "Si",
    no: "No",
    confirmed: "Confirmado",
    invited: "Ingresado",
    callPending: "Llamada Pendiente",
    nextTime: "Próxima Vez",
    pending: "Pendiente",
    paymentComplete: "Completo",
    paymentPartial: "Parcial",
    brand: "Marca",
    plate: "Placa",
    transfer: "Transferencia",
    cash: "Efectivo",
    check: "Cheque",
    other: "Otro",
    edit: "Editar",
    call: "Llamada",
    date: "Fecha",
    eventDoneMessage: "El retiro ya fue realizado el {date}",
    addInvitation: "Crear invitación",
    servicesTabTitle: "Asambleas",
    serversTabTitle: "Servidores",
    groupServersEdit: "Detalles del Servidor",
    groupServersGridTitle: "Servidores del Grupo",
    groupServersGridColName: "Nombre",
    attendancePendingTitle: "Pendientes de Asistencia",
    attendanceNotToday: "La asistencia solo se puede marcar los dias del retiro ({date}).",
    groupServersGridColPhone: "Teléfono",
    groupServersGridColGender: "Sexo",
    attendanceTitle: "Asistencia",
    attendanceIndicatorTitle: "Conteo de Asistencia",
    groupServersGridColLastName: "Apellido",
    groupServersGridColMaritalStatus: "Estado Civil",
    groupServersGridColConvertionDate: "Fecha de Conversión",
    groupServersGridColEmail: "Correo",
    noAccessText: "No tienes permisos para acceder a este recurso",
    meetingOfDay: "Reunión del día {day}",
    meetingServiceFormServiceName: "Agregar comisión",
    meetingServiceFormDescription: "Descripción",
    meetingServiceFormDate: "Fecha del servicio",
    addServer: "Agregar servidor",
    editServer: "Editar servidor",
    attendanceGridColName: "Nombre",
    attendanceGridColAge: "Edad",
    attendanceGridColLastName: "Apellido",
    attendanceGridColPhone: "Teléfono",
    attendanceGridColRoom: "Habitación",
    attendanceGridColHouse: "Casa",
    attendanceGridColWorkshop: "Taller",
    attendanceGridColAttendance: "Asistencia",
    attendanceGridColPayment: "Pago",
    attendanceGridColViewProfile: "Ver Perfil",
    assignWorkshopsByAge: "Asignar talleres por edad",
    groups: "Grupos",
    all: "Todos",
    of: "de",
    paymentsList: "Lista de pagos",
    rooms: "Habitaciones",
    roomsNoEditAccess: "No tienes permisos para editar habitaciones",
    currentTotalServers: "Total actual de servidores",
    groupByAgeBarChartTitle: "Servidores por Edad",
    groupByMaritalStatusBarChartTitle: "Servidores por Estado Civil",
    groupByMinistryBarChartTitle: "Servidores por Ministerio",
    groupByConvertionYearsBarChartTitle: "Servidores por Años de Conversión",
    nextRetreats: "Próximos retiros",
    available: "Disponible",
    notAvailable: "No Disponible",
    priests: "Sacerdotes",
    firstFloor: "1er Nivel",
    secondFloor: "2do Nivel",
    marysHouse: "Casa de María",
    searchRoomsPlaceholder: "Buscar por número de habitación...",
    noConnection: "No hay conexión a internet",
    confirmUpdateWorkshopsByAge: "¿Estás seguro de querer actualizar los talleres por edad?",
    configWorkshopsCount: "Configurar cantidad de talleres",
    uploadPayment: "Subir Pago",
    paymentsHistory: "Historial de pagos",
    accept: "Aceptar",
    availableBeds: "Camas Disp",
    dashboard: "Dashboard",
    assignedServices: "Asignación de Servicios",
    assignServicesCaption: "Asigna servidores a los servicios para las próximas reuniones",
    selectMeetingHelperText: "Por favor selecciona una reunión para comenzar a asignar servicios",
    serversManagement: "Administración de Servidores",
    serversManagementCaption: "Administra servidores y sus habilidades de servicio",
    noMeetingSelected: "No hay reunión seleccionada",
    servicesManagement: "Administración de Servicios",
    servicesManagementCaption: "Administra los diferentes servicios necesarios para las reuniones",
    services: "Servicios",
    upcommingMeetings: "Próximas reuniones",
    upcommingMeetingsCaption: "Ver y administrar las próximas reuniones",
    calendar: "Calendario",
    calendarCaption: "Selecciona una fecha para ver las reuniones",
    serviceStats: "Estadísticas de Servicio",
    serviceStatsCaption: "Resumen de las asignaciones de servicio",
    quickActions: "Acciones Rápidas",
    quickActionsCaption: "Tareas y acciones comunes",
    filterByCallName: "Filtrar por encargado",
    paymentNotes: "Notas de Pago",
    paymentNotesPlaceholder: "Agregar notas de pago (becas o descuentos)",
    history: "Historial",
    noRecordsFound: "No se encontraron registros",
    selectEventPlaceholder: "Seleccionar un retiro",
    groupHasNoEvents: "El grupo no tiene retiros disponibles",
    createNewEvent: "Crear nuevo retiro",
    openFilters: "Abrir Filtros",
    ...commitmentTranslations.es
  }
};
